import { combineReducers } from "redux";
import authReducer from "./authReducer";
import bannersReducer from "./bannerReducer";
import bookingsReducer from "./bookingReducer";
import doneeReducer from "./doneeReducer";
import eventReducer from "./eventReducer";
import ngoReducer from "./ngoReducer";
import utilsReducer from "./utilsReducer";

const rootReducer = combineReducers({
  authStore: authReducer,
  bookingStore: bookingsReducer,
  eventStore: eventReducer,
  ngoStore: ngoReducer,
  bannerStore: bannersReducer,
  utilsStore: utilsReducer,
  doneeStore: doneeReducer,
});

export default rootReducer;
